export default __webpack_public_path__ + "static/media/nearby.3fb5db81.svg";